// extracted by mini-css-extract-plugin
export default {"root":"EventLinks_root__evwMh"};